import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  TextField,
  Autocomplete,
  FormControl,
  InputLabel,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch } from "react-redux";
import { helperServices } from "../../shared/helper";
import { doctorActions } from "../../core/actions";
import personDetailsService from "../../core/services/personDetailsService";

function VisitsByType(props) {
  const dispatch = useDispatch();

  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [selectedFloor, setSelectedFloor] = useState(null);
  const [selectedDep, setSelectedDep] = useState(null);

  const [doctorList, setDoctorList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [floorList, setFloorList] = useState([]);

  const [data, setData] = useState({
    targetId: "",
    floorId: "",
    department: "",
    selectedOption: "",
  });

  // Fetch data on mount
  useEffect(() => {
    getDoctorsList();
    getDepartmentList();
    getFloorList();
  }, []);

  const handleSelection = (type, value) => {
    let updatedData = { ...data };

    if (type.toLowerCase() === "doctor") {
      setSelectedDoctor(value);
      setSelectedFloor(null);
      setSelectedDep(null);
       console.log("doctorIdddd",value);
      updatedData = {
        targetId: value?.gvId?? "",
        floorId: "",
        department: "",
        selectedOption: value?.label || "",
      };
    } else if (type.toLowerCase() === "floor") {
      setSelectedFloor(value);
      setSelectedDoctor(null);
      setSelectedDep(null);
      updatedData = {
        targetId: "",
        department: "",
        floorId: value?.floorid ?? "", // 👈 use correct casing
        selectedOption: value?.floorname ?? "",
      };
    } else if (type.toLowerCase() === "dep") {
      setSelectedDep(value);
      setSelectedDoctor(null);
      setSelectedFloor(null);
      updatedData = {
        targetId: "",
        floorId: "",
        department: value?.id ?? "",
        selectedOption: value?.name || "",
      };
    }

    setData(updatedData);
    sessionStorage.setItem("visitDetailsBy", JSON.stringify(updatedData));
  };

  const handleSubmit = () => {
    props.close(data);
  };

  const closeModal = () => {
    props.close();
  };

  // === Data Fetching ===

  const getDoctorsList = () => {
    try {
      const doctorsDetail = personDetailsService.getDoctorsDetail() || [];
      console.log("Raw doctors data:", doctorsDetail);

      if (!Array.isArray(doctorsDetail)) {
        setDoctorList([{ id: 0, label: "All Patient" }]);
        return;
      }

      const list = doctorsDetail
        .filter((doc) => doc != null)
        .map(helperServices.buildDoctorOption) // ← correct usage
        .filter(
          (item) =>
            (item.type || "").toLowerCase() === (props.type || "").toLowerCase()
        );

      const finalList = [{ id: 0, label: "All Patient" }, ...list];

      console.log("Filtered doctor list:", finalList);
      setDoctorList(finalList);
    } catch (error) {
      console.error("Error in getDoctorsList:", error);
      setDoctorList([{ id: 0, label: "All Patient" }]);
    }
  };

  const getDepartmentList = () => {
    dispatch(
      doctorActions.getDepartmentList(null, (resCb) => {
        if (resCb && Array.isArray(resCb)) {
          const list = resCb.map((dept) => ({
            id: dept.id,
            name: dept.name,
          }));
          setDepartmentList(list);
        } else {
          setDepartmentList([]);
        }
      })
    );
  };

  const getFloorList = () => {
    dispatch(
      doctorActions.getFloorList(null, (resCb) => {
        if (resCb && Array.isArray(resCb)) {
          const list = resCb.map((floor) => ({
            floorid: floor.floorId,
            floorname: floor.floorName,
          }));
          setFloorList(list);
        } else {
          setFloorList([]);
        }
      })
    );
  };

  return (
    <Dialog open={true} onClose={closeModal} maxWidth="sm" fullWidth>
      <DialogTitle>
        Today's Visit Details
        <IconButton
          aria-label="close"
          onClick={closeModal}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Box sx={{ mt: 1, mb: 2 }}>
          <Autocomplete
            options={doctorList}
            getOptionLabel={(option) => option.label || ""}
            value={selectedDoctor}
            onChange={(event, newValue) => handleSelection("Doctor", newValue)}
            renderInput={(params) => (
              <TextField {...params} label="Select Doctor" />
            )}
            isOptionEqualToValue={(option, value) => option.id === value?.id}
            size="small"
          />
        </Box>

        <Box sx={{ mt: 1, mb: 2 }}>
          <Autocomplete
            options={floorList}
            getOptionLabel={(option) => option.floorname || ""}
            value={selectedFloor}
            onChange={(event, newValue) => handleSelection("Floor", newValue)}
            renderInput={(params) => (
              <TextField {...params} label="Select Floor" />
            )}
            isOptionEqualToValue={(option, value) =>
              option.floorid === value?.floorid
            }
            size="small"
          />
        </Box>

        <Box sx={{ mt: 1, mb: 2 }}>
          <Autocomplete
            options={departmentList}
            getOptionLabel={(option) => option.name || ""}
            value={selectedDep}
            onChange={(event, newValue) => handleSelection("Dep", newValue)}
            renderInput={(params) => (
              <TextField {...params} label="Select Department" />
            )}
            isOptionEqualToValue={(option, value) => option.id === value?.id}
            size="small"
          />
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={closeModal} color="secondary">
          Cancel
        </Button>
        <Button variant="contained" color="primary" onClick={handleSubmit}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default VisitsByType;
